
(function pdfViewerIeModuleDefinition(){

    angular.module('PDFViewerIe', ['Language']);

})();